import React, {useState} from "react";
import './BlockNews.css';
import {MonthToText} from "../../../../AdminPart/src/Constants";

function createDangerHTML(info) {
    return {__html : info}
}
/*
const AllNewsArr = [
    { id: 0, year: '2017', month:'05', date:'29', title: 'День памяти в США', text: "Индексы USA30, USA500 – раннее закрытие 23 00 МСК" },
    { id: 1, year: '2018', month:'05', date:'29', title: 'Колян - жми на года', text: "Жми-жми не стесняйся" },
    { id: 2, year: '2017', month:'05', date:'22', title: 'Борьба с мошенниками', text: "В последнее время участились случаи, когда мошенники под разными предлогами пытаются ,......" },
];*/

function BlockNews(props) {
    const [FXBitcoinNews, setFXBitcoinNews] = useState(['BlockNewsChangeMarked','BlockNewsChangeMarkedNo','BlockNewsChangeMarkedNo']);
    const [FXBitcoinNewsNumber, setFXBitcoinNewsNumber] = useState(0);

    function TakeThisNew(numberNew) {
            const ArrFXBitcoinNews = ['BlockNewsChangeMarkedNo','BlockNewsChangeMarkedNo','BlockNewsChangeMarkedNo'];
            ArrFXBitcoinNews[numberNew] = 'BlockNewsChangeMarked';
            setFXBitcoinNewsNumber(numberNew);
            setFXBitcoinNews(ArrFXBitcoinNews);
        }
            //console.log('4444',props.ArrayNews)
    return (
        <div className="CompanyNewsGridElement">
            <div className="CompanyNewsGridElementTop">
            <div className="CompanyNewsGridElementTopTitle"> Новости </div>
                <div className="block_news_change">
                    <div className={FXBitcoinNews[0]}  role = "button" tabIndex={0} onKeyPress={() => {}} onClick={() => TakeThisNew(0)} aria-label="Next News"> </div>
                    <div className={FXBitcoinNews[1]}  role = "button" tabIndex={0} onKeyPress={() => {}} onClick={() => TakeThisNew(1)} aria-label="Next News"> </div>
                    <div className={FXBitcoinNews[2]}  role = "button" tabIndex={0} onKeyPress={() => {}} onClick={() => TakeThisNew(2)} aria-label="Next News"> </div>
                </div>
            </div>
            <div className="CompanyNewsGridElementDateOut">
                <div className={"CompanyNewsGridElementIMG " + (props.ArrayNews[FXBitcoinNewsNumber][7] ? props.ArrayNews[FXBitcoinNewsNumber][7] : 'CompanyNewsGridElementImg02')}/>
                <div className="block_news_data">
                    {props.ArrayNews[FXBitcoinNewsNumber][3] + ' ' + MonthToText(props.ArrayNews[FXBitcoinNewsNumber][2],props.lang) }
                </div>
            </div>


            <div className="CompanyNewsGridElementText">
                <div className="CompanyNewsGridElementTextTitleDate">
                    <div className="CompanyNewsGridElementTextTitle" dangerouslySetInnerHTML= {createDangerHTML(props.ArrayNews[FXBitcoinNewsNumber][0])}/>
                    <div className="CompanyNewsGridElementTextDate" dangerouslySetInnerHTML= {createDangerHTML(props.ArrayNews[FXBitcoinNewsNumber][5])}/>
                </div>
                <div className="CompanyNewsGridElementTextNews">{props.NewText}</div>
            </div>
        </div>
)}

export default BlockNews
